module.exports = __webpack_public_path__ + "media/images/logo_e_boekhouden-05dd0d42e9fb7f993fd455c0ad26a80a.svg";